import { Attribute } from '../Model/Attribute';
import { ProductInterface } from '../Model/Product';
import { ObjectUtility } from '../Service/ObjectUtility';
import { AbstractFilter } from './AbstractFilter';
import { FilterInterface } from './FilterInterface';
import { RangeFilterValue } from './RangeFilterValue';

export interface RangeFilterValueType {
    min: number,
    max: number
}

export class RangeFilter<T extends RangeFilterValueType = RangeFilterValueType> extends AbstractFilter<T> {
    public matches(product: ProductInterface): boolean {
        const testValue = this.getProductTestValue(product);
        const expectedValue = this.value;
        if (testValue === undefined) {
            return false;
        }

        return (expectedValue.min <= testValue && testValue <= expectedValue.max);
    }

    protected getClearValue(): any | T | undefined {
        return RangeFilterValue.empty();
    }

    protected clone(): FilterInterface<T> {
        return new RangeFilter(this.keyPath, this.value, this.type, this.isActive);
    }

    private getProductTestValue(product: ProductInterface): number | undefined {
        const productValue = ObjectUtility.valueForKeyPath(
            product,
            this.keyPath
        ) as Partial<Attribute> | string | number;
        if (typeof productValue === 'undefined') {
            return undefined;
        }
        if (productValue === null) {
            return undefined;
        }

        if (typeof productValue === 'string') {
            return parseInt(productValue, 10);
        }
        if (typeof productValue === 'number') {
            return productValue;
        }

        if (typeof productValue.numericValue === 'number') {
            return productValue.numericValue;
        }
        if (typeof productValue.displayString !== 'undefined') {
            return parseInt(productValue.displayString, 10);
        }

        console.error(`Could not fetch range-test value for ${this.keyPath} from Product`, product);

        return undefined;
    }
}
